var exports = {
  "kJ": "GiftEmbed.module__iconCircle___OVFoNV",
  "SP": "GiftEmbed.module__iconCircleActive___OVFoNV",
  "PP": "GiftEmbed.module__iconCircleInactive___OVFoNV",
  "_O": "GiftEmbed.module__iconCircleDisabled___OVFoNV",
  "Kk": "GiftEmbed.module__icon___OVFoNV",
  "m5": "GiftEmbed.module__iconError___OVFoNV",
  "DD": "GiftEmbed.module__title___OVFoNV",
  "jn": "GiftEmbed.module__titlePrimary___OVFoNV",
  "xP": "GiftEmbed.module__titleTertiary___OVFoNV",
  "S3": "GiftEmbed.module__titleDanger___OVFoNV",
  "xF": "GiftEmbed.module__subRow___OVFoNV",
  "Cz": "GiftEmbed.module__helpRow___OVFoNV",
  "U6": "GiftEmbed.module__pulse___OVFoNV",
  "mj": "GiftEmbed.module__skeletonCircle___OVFoNV",
  "Iz": "GiftEmbed.module__skeletonTitle___OVFoNV",
  "hI": "GiftEmbed.module__skeletonHelp___OVFoNV",
  "G3": "GiftEmbed.module__skeletonButton___OVFoNV",
};

module.exports = exports;
